import { formValueSelector } from 'redux-form'

import {
  pipe,
  last,
  trim,
  split,
  replace,
  both,
  contains,
  isNil,
  complement,
  is
} from 'ramda'
const getFieldName = pipe(trim, split('.'), last)

const selector = formValueSelector('widget')

// Replace the last property in the field path with 'media'
// e.g. actions[0].success[0].message becomes actions[0].success[0].media
const replaceMediaFieldPath = replace(/\.\w+$/, '.media')

const isDefined = complement(isNil)
const isString = is(String)

const isActionFieldWithMedia = both(isDefined, contains('message'))
const isTriggerFieldWithMedia = both(isDefined, contains('value'))

/**
 * Fetch the value of the provided fieldPath & append it to the props object
 *
 * @param {object} state current redux state
 * @param {object} props property object field must be added to
 * @param {object} fieldPath field path (e.g. actions[0].success[0].message)
 * @returns {void}
 */
function appendField (state, props, fieldPath) {
  const fieldName = getFieldName(fieldPath)
  props[fieldName] = selector(state, fieldPath)
}

/**
 * Fetch the media of the provided fieldPath & append it to the props object
 *
 * @param {object} state current redux state
 * @param {object} props property object media field must be added to
 * @param {object} fieldPath field path (e.g. actions[0].success[0].message)
 * @returns {void}
 */
const appendMediaField = (state, props, fieldPath) => {
  const mediaFieldPath = replaceMediaFieldPath(fieldPath)
  appendField(state, props, mediaFieldPath)
}

/**
 * Composes an object with properties and their values from the Redux state &
 * React Component Properties object.
 *
 * @param {object} state current redux state
 * @param {object} ownProps react field properties object
 * @returns {object} properties with their values
 */
const mapStateToProps = (state, ownProps) => {
  if (!ownProps) {
    return {}
  }

  const newProps = {}
  const propertyValues = Object.values(ownProps)
  const stringValues = propertyValues.filter(isString)

  stringValues.map(value => {
    if (isActionFieldWithMedia(value) || isTriggerFieldWithMedia(value)) {
      appendMediaField(state, newProps, value)
    }

    appendField(state, newProps, value)
    return value
  })

  return newProps
}

export { mapStateToProps }



// WEBPACK FOOTER //
// ./src/pages/widgets/form/tweet-input/util.js